import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import Layout from 'components/templates/layout';
import { useIntl } from 'common/config/i18n';
import { StyledMainTitle, StyledListUtil, StyledBlueLink } from 'common/styling/mixins';
import { FluxClientsFilters } from 'types';
import CustomersFilter from 'components/templates/customers-filter';
import history from 'app-router/history';
import { customersListSelectors, customersListActions } from 'common/config/store';
import CustomersByODList from 'components/templates/customers-by-od-list';
import useFromMenu from 'hooks/use-from-menu';

const { StyledListWrapper, StyledListTitleWrapper } = StyledListUtil;

const Customers: React.FC = () => {
  const { t } = useIntl();
  const dispatch = useDispatch();
  const isFromMenu = useFromMenu({ clearAfterRead: true });

  const status = useSelector(customersListSelectors.customersByODStatusSelector);
  const data = useSelector(customersListSelectors.customersByODDataSelector);
  const filterValues = useSelector(customersListSelectors.filtersSelector);

  useEffect(() => {
    // We wait untill isFromMenu has a value (false or true)
    if (isFromMenu !== null) {
      if (isFromMenu) {
        dispatch(customersListActions.resetFilters());
        dispatch(
          customersListActions.fetchCustomersByOD({
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            pageNumber: 1,
            maxResultPage: 6,
            includedCancel: false,
            includedRolling: false,
          })
        );
      } else {
        dispatch(
          customersListActions.setFilters({
            ...filterValues,
            station: undefined,
            arrivalStation: undefined,
            departureStation: undefined,
          })
        );
        dispatch(
          customersListActions.fetchCustomersByOD({
            ...filterValues,
            startDate: moment(filterValues.startDate).format('YYYY-MM-DD'),
            endDate: moment(filterValues.endDate).format('YYYY-MM-DD'),
            station: undefined,
            arrivalStation: undefined,
            departureStation: undefined,
          })
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFromMenu]);

  const launchAction = (values: FluxClientsFilters, action: (params: FluxClientsFilters) => void) => {
    const params = {
      ...values,
      startDate: moment(values.startDate).format('YYYY-MM-DD'),
      endDate: moment(values.endDate).format('YYYY-MM-DD'),
      pageNumber: 1,
      maxResultPage: 6,
    };
    dispatch(customersListActions.setFilters(params));
    dispatch(action(params));
  };

  const fetchAction = (values: FluxClientsFilters) => {
    launchAction(values, customersListActions.fetchCustomersByOD);
  };
  const refreshAction = (values: FluxClientsFilters) => {
    launchAction(values, customersListActions.refreshCustomersByOD);
  };
  const exportListAction = (values: FluxClientsFilters) => {
    launchAction(values, customersListActions.exportCustomersByOD);
  };
  return (
    <div>
      <Layout />
      <StyledListWrapper>
        <StyledMainTitle withMarginBottom>{t('customersODPage', 'title')}</StyledMainTitle>
        <StyledListTitleWrapper>
          <StyledBlueLink
            noDecoration
            onClick={() => {
              history.replace('/customers/station');
            }}
          >
            {t('customersStationPage', 'linkStation')}
          </StyledBlueLink>
        </StyledListTitleWrapper>
        <CustomersFilter
          status={status}
          searchDate={data?.searchTimestamp}
          mode="customersByOD"
          fetchAction={fetchAction}
          refreshAction={refreshAction}
          exportListAction={exportListAction}
        />
        {status === 'success' && <CustomersByODList data={data} filterValues={filterValues} />}
      </StyledListWrapper>
    </div>
  );
};

export default Customers;
